import { z } from "zod";
import { FOCUS_AREA_DAYS_PER_LEVEL, focusAreaLevelProgress, focusAreaMeta, HABIT_TARGET_DAYS, habitStage, habitStageSchema, } from "./focus-areas.js";
import { BEHAVIOUR_LABELS, healthBehaviourSchema, } from "./health-behaviours.js";
/**
 * A behaviour's level is the focus-area level system, read from the days the
 * member actually practised: five distinct days is a level, twenty-one is an
 * established habit. Nothing here is awarded by a calendar.
 */
export const snapshotLevelSchema = z.object({
    behaviour: healthBehaviourSchema,
    label: z.string(),
    focusAreaId: z.string(),
    /** The focus area the behaviour is working on, in the member's words. */
    habit: z.string(),
    why: z.string(),
    level: z.number().int().min(1),
    /** Distinct days practised across the window. */
    days: z.number().int().min(0),
    daysThisLevel: z.number().int().min(0),
    daysPerLevel: z.number().int().min(1),
    daysThisWeek: z.number().int().min(0),
    stage: habitStageSchema,
    habitTargetDays: z.number().int().min(1),
    habitEstablished: z.boolean(),
});
/** The focus area each behaviour's practice counts toward. */
export const SNAPSHOT_DEFAULT_FOCUS_AREA = {
    sleep: "winding-down",
    movement: "everyday-activity",
    stress: "mind-checkins",
    food: "meal-rhythm",
    connection: "staying-connected",
};
export function buildSnapshotLevel(behaviour, distinctDays, daysThisWeek, focusAreaId = SNAPSHOT_DEFAULT_FOCUS_AREA[behaviour]) {
    const area = focusAreaMeta(focusAreaId);
    const progress = focusAreaLevelProgress(distinctDays);
    return {
        behaviour,
        label: BEHAVIOUR_LABELS[behaviour],
        focusAreaId: area.id,
        habit: area.label,
        why: area.why,
        level: progress.level,
        days: Math.max(0, Math.floor(distinctDays) || 0),
        daysThisLevel: progress.daysThisLevel,
        daysPerLevel: progress.daysPerLevel,
        daysThisWeek,
        stage: habitStage(distinctDays),
        habitTargetDays: HABIT_TARGET_DAYS,
        habitEstablished: progress.habitEstablished,
    };
}
export { FOCUS_AREA_DAYS_PER_LEVEL, HABIT_TARGET_DAYS };
//# sourceMappingURL=snapshot-levels.js.map